import { http } from '@/libs'
import type { SecurityBeginReq, SecurityBeginData } from './types'

export { http }
// 统一封装 begin 接口，后续可插入重试/鉴权
export async function apiSecurityBegin(payload: SecurityBeginReq) {
  return http.call<SecurityBeginData>({
    url: '/api/security/begin',
    method: 'POST',
    data: payload,
    useAuth: false,
  })
}

// 获取开启 MFA 的业务模块清单
export async function apiSecurityList(): Promise<
  Array<{ model_code: string; model_value: string }>
> {
  return http.call<{ model_code: string; model_value: string }[]>({
    url: '/api/security/list',
    method: 'POST',
    useAuth: false,
  })
}
